<template>
  <div
    class="skeleton-box"
    :class="[variant, colorTheme, { square: square }]"
    :style="customStyle"
  ></div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  width: {
    type: String,
    default: '100%'
  },
  height: {
    type: String,
    default: '20px'
  },
  variant: {
    type: String,
    default: 'default', // 'default', 'circle', 'text', 'image'
  },
  colorTheme: {
    type: String,
    default: 'dark', // 'light', 'dark', 'red'
  },
  square: {
    type: Boolean,
    default: false
  }
});

const customStyle = computed(() => ({
  width: props.width,
  height: props.height
}));
</script>

<style lang="scss" scoped>
.skeleton-box {
  background-size: 200% 100%;
  animation: shimmer 1.8s ease-in-out infinite;
  border-radius: 8px;
}

/* Square corners */
.skeleton-box.square {
  border-radius: 0;
}

/* Circle variant */
.skeleton-box.circle {
  border-radius: 50%;
}

/* Text variant */
.skeleton-box.text {
  border-radius: 4px;
  height: 16px;
}

/* ===== COLOR THEMES ===== */

/* Dark theme (for #333 backgrounds - listings, etc.) */
.skeleton-box.dark {
  background: linear-gradient(
    90deg,
    #2a2a2a 0%,
    #3d3d3d 50%,
    #2a2a2a 100%
  );
}

.skeleton-box.dark.image {
  background: linear-gradient(
    90deg,
    #282828 0%,
    #404040 50%,
    #282828 100%
  );
}

/* Light theme (for white backgrounds - navigation, etc.) */
.skeleton-box.light {
  background: linear-gradient(
    90deg,
    #e8e8e8 0%,
    #f0f0f0 50%,
    #e8e8e8 100%
  );
}

.skeleton-box.light.image {
  background: linear-gradient(
    90deg,
    #e0e0e0 0%,
    #f0f0f0 50%,
    #e0e0e0 100%
  );
}

/* Red theme (for #77122d backgrounds - show home, etc.) */
.skeleton-box.red {
  background: linear-gradient(
    90deg,
    #6a1028 0%,
    #851634 50%,
    #6a1028 100%
  );
}

.skeleton-box.red.image {
  background: linear-gradient(
    90deg,
    #5f0e24 0%,
    #8f1838 50%,
    #5f0e24 100%
  );
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
